const periods = [
  "lastValue",
  "lastHour",
  "today",
  "yesterday",
  "thisWeek",
  "last7Days",
  "last14Days",
  "last30Days",
  "last60Days",
  "thisYear",
  "custom", // Don't add items after custom
];

const scheduleTypes = ["12Hours", "24Hours"];

const configInitialValues = {
  deviceId: "",
  variableId: "",
  period: "lastHour",
  dateFrom: "",
  dateTo: "",
  scheduleType: scheduleTypes[1],
  groupBy: "",
  chartColor: "#437dd1",
  autoRefresh: false,
  width: 370,
  height: 200,
  graphBy: "",
  companyId: "",
  branchId: "",
};

const operators = ["<", "<=", "==", ">=", ">", "!="];

const timePeriodicity = ["monthly", "weekly", "daily", "hourly", "realtime"];

const lastTime = [
  "lastMinutes",
  "lastHours",
  "lastDays",
  "lastWeeks",
  "lastMonths",
];

const valueTypes = ["none", "list", "number"];

const days = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

const serviceOrderStatus = {
  created: "created",
  scheduled: "scheduled",
  executed: "executed",
  canceled: "canceled",
  executing: "executing",
};

const spareStatus = {
  available: "available",
  assignedInOrder: "assignedInOrder",
  installedInEquipment: "installedInEquipment",
};

export {
  periods,
  scheduleTypes,
  configInitialValues,
  operators,
  timePeriodicity,
  lastTime,
  valueTypes,
  days,
  serviceOrderStatus,
  spareStatus
};
